import { vnTemplate } from "@valnet/vnKnockoutJsTemplates/vnTemplate";
import { getActiveSectionLabel } from "~/modules/menu_data";
import { html, LpPageHeader } from "~/design-system";
export class pageShell_template extends vnTemplate {
    constructor(templateId, viewModel, caller, pageTitle, navLinks = []) {
        super(templateId, viewModel, caller);
        this.pageTitle = pageTitle;
        this.navLinks = navLinks;
    }
    getTemplateHtml() {
        return /* html */ `
            ${LpPageHeader({
            title: html `<span data-bind="text: pageTitle"></span>`,
            description: html `<span data-bind="text: pageLead"></span>`,
            icon: "folder-simple",
        })}

            <div class="page-shell">
                <section class="data-module page-shell__module">
                    <div class="data-module__body page-shell__body">
                        <!-- ko if: hasNavLinks -->
                            <p class="page-shell__lead" data-bind="text: pageLead"></p>
                            <nav class="page-shell__nav" aria-label="Section pages">
                                <ul class="page-shell__nav-list" data-bind="foreach: navLinks">
                                    <li>
                                        <a
                                            class="page-shell__nav-link"
                                            data-bind="
                                                attr: { href: url, 'aria-current': isActive ? 'page' : null },
                                                css: { 'is-active': isActive }
                                            "
                                        >
                                            <span data-bind="text: text"></span>
                                        </a>
                                    </li>
                                </ul>
                            </nav>
                        <!-- /ko -->
                        <!-- ko ifnot: hasNavLinks -->
                            <div class="page-shell__empty">
                                <p class="page-shell__empty-text" data-bind="text: pageLead"></p>
                            </div>
                        <!-- /ko -->
                    </div>
                </section>
            </div>
        `;
    }
    getTemplateName() {
        return "pageShell-template";
    }
    buildViewModel() {
        const hasNavLinks = this.navLinks.length > 0;
        return {
            pageTitle: this.pageTitle,
            pageLead: hasNavLinks
                ? this.pageTitle === "Home"
                    ? "Choose a section to get started."
                    : `Choose a page in ${getActiveSectionLabel()}.`
                : `Content for ${this.pageTitle} will appear here.`,
            navLinks: this.navLinks,
            hasNavLinks,
        };
    }
}
